module.exports = "\n<app-nav-bar></app-nav-bar>\n<app-elecciones-grid></app-elecciones-grid>"